import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token: '',
      userguid:'',
      nickname:'',
      shopid:"",
      otheruserguid : '',
      shopname:"",
      userid:"",
      user:{
        days:'',//注册天数
        isReturnPlayer:'',//是否可以领取回归礼包 (1-是 0-否)
        lastDays:'',//最后登录距今天数
        lastTime:'',//最后登录时间
        regTime:'',//注册时间
      },
      drama:{
        dramaCount:'',//剧本数量
        escapeCount:'',//逃脱次数
        firstDramaName:'',//第一次剧本名称
        latestTime:'',//玩到最晚的时间
        longestTimeDramaName:'',//玩到最晚的时间的剧本名
        murdererCount:'',//凶手次数
        longestDramaTime:'',//玩的最晚剧本的耗时时间
      },
      gift:{
        giftCount:'',//礼物送出数量
        receiveGiftCount:"",//收到礼物数量
        giftDiamondCount :"" ,//消费钻石数量
        charm : ""//总魅力值
      },
      couple:{
        avatar:'',//cp头像
        nickname:'',// 昵称
        level :'',// 等级
        age :'',// 年龄
        sex :'',// 性别
        coupleValue :'',// cp值
        dramaCount :'',// 一起玩剧本数量
        coupleValuePercentage :'',// 击败cp百分比
        togetherDays :'',// 在一起天数
        giftCount :'',// 你送给ta礼物数量
        receiveGiftCount :'',// 你收到ta礼物数量
      },
      werewolf:{
        gameCount: '',
        wolfCount: '',
        winCount: ''
      },
      //支付
      orderno:"",
      ordertime:'',
      payinfo:{
        name:'',
        phone:'',
        address:'',
        uid:'',
      },
      starttime: '',
      endtime:''
  },
  mutations: {
    saveToken(state, token) {
      state.token =token
    },
    saveUserGuid(state, userguid) {
      state.userguid =userguid
    },
    saveShopId(state, shopid) {
      state.shopid =shopid
    },
    saveNickName(state, nickname){
      state.nickname =nickname
    },
    saveOtherUserGuid(state, otheruserguid){
      state.otheruserguid = otheruserguid
    },
    saveShopName(state, shopname){
      state.shopname = shopname
    },
    saveUserId(state, userid){
      state.userid = userid
    },
    //周年庆活动数据
    saveUser(state,user){
      state.user=user
    },
    saveDrama(state,drama){
      state.drama=drama
    },
    saveGift(state,gift){
      state.gift=gift
    },
    saveCouple(state,couple){
      state.couple=couple
    },
    saveWerewolf(state,werewolf){
      state.werewolf = werewolf
    },
    // 支付
    saveOrderNo(state,orderno){
      state.orderno=orderno
    },
    saveOrderTime(state,ordertime){
      state.ordertime=ordertime
    },
    savePayInfo(state,payinfo){
      state.payinfo=payinfo
    },
    SaveStartTime(state,starttime){
      state.starttime = starttime
    },
    SaveEndTime(state,endtime){
      state.endtime = endtime
    }
    
  },
  actions: {
    Token(context,token) {
      context.commit('saveToken',token)
    },
    UserGuid(context,userguid) {
      context.commit('saveUserGuid',userguid)
    },
    ShopId(context,shopid) {
      context.commit('saveShopId',shopid)
    },
    NickName(context,nickname){
      context.commit('saveNickName',nickname)
    },
    OtherUserGuid(context, otheruserguid){
      context.commit('saveOtherUserGuid',otheruserguid)
    },
    ShopName(context, shopname){
      context.commit('saveShopName',shopname)
    },
    UserId(context, userid){
      context.commit('saveUserId',userid)
    },
  //周年庆活动数据
    User(context,user){
      context.commit('saveUser',user)
    },
    Drama(context,drama){
      context.commit('saveDrama',drama)
    },
    Gift(context,gift){
      context.commit('saveGift',gift)
    },
    Couple(context,couple){
      context.commit('saveCouple',couple)
    },
    Werewolf(context,werewolf){
      context.commit('saveWerewolf',werewolf)
    },
    //排行榜 
    Starttime(context,starttime){
      context.commit('SaveStartTime',starttime)
    },
    Endtime(context,endtime){
      context.commit('SaveEndTime',endtime)
    },
    //购买信息
    PayInfo(context,payinfo){
      context.commit('savePayInfo',payinfo)
    },
   
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js